// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"PrivayPolicyStyle_backdrop__7KtRX","content":"PrivayPolicyStyle_content__3tm69","divider":"PrivayPolicyStyle_divider__1M45e"};